import { render, staticRenderFns } from "./OtsMainTitle.vue?vue&type=template&id=6d1bc73c&scoped=true&"
import script from "./OtsMainTitle.vue?vue&type=script&lang=js&"
export * from "./OtsMainTitle.vue?vue&type=script&lang=js&"
import style0 from "./OtsMainTitle.vue?vue&type=style&index=0&id=6d1bc73c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1bc73c",
  null
  
)

export default component.exports